export default "__VITE_ASSET__Bdv$dbFQ__"